<div class="property-main-content" id="property-main-content" fxLayout="row" fxLayoutAlign="space-between" (swiperight)="backSwipe()" (swipeleft)="forwardSwipe()">
    <div class="arrow-div" fxLayout="column" fxLayoutAlign="center center">
     <evc-nav-button [disabled]="!isBackImage || !isLoadedImg || isPreviewReport" [rightIcon]="'angle-left'" type="cta" variant="round" (click)="changeIndex(true)" size="sm"/>
    </div>

  <div fxLayout="column" class="dialog-container" fxLayoutGap="10px">
    <div fxLayout="row" class="inspection-image-div">
      <div fxLayoutAlign="start" class="img-div">
        <img id="displayImg" class="display-insp-img" alt=""
          src="{{isLoadedImg && inspectionImage ? inspectionImage.filePath : null}}">
      </div>

      <div class="properties-container" id="property-area">
        <!--audio-->
        <div *ngIf="inspectionImage.audioFilePath && !isOnline" class="property-form audio-area">
          <audio class="audio-contents" [src]="inspectionImage.audioFilePath" controls></audio>
        </div>
        <div *ngIf="inspectionImage.uploadAudioUrl && isOnline" class="property-form audio-area">
          <audio class="audio-contents" id="online-audio" [src]="inspectionImage.uploadAudioUrl" controls></audio>
        </div>
        @if(inspectionImage){
           <app-image-metadata-card [imageMetadata]="imageMetadata" [properties]="properties"></app-image-metadata-card>
        }

      </div>
    </div>
  </div>

  <div class="arrow-div" fxLayout="column" fxLayoutAlign="center center">
     <evc-nav-button [disabled]="!isForwardImage || !isLoadedImg || isPreviewReport" [rightIcon]="'angle-right'" type="cta" variant="round" (click)="changeIndex(false)" size="sm"/>
  </div>

</div>
